module.exports = __webpack_public_path__ + "images/contest-sent-4a1ef3da58742428d72e3d74fdb80b86.png";